import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { map } from 'rxjs/operators';

import {
  GetActionNameGQL, GetTagsByIdsForQueryQuery, SearchActivityEvents
} from 'generated/graphql';

import { MassAddEntitiesToActionOperationData } from 'app/quick-apply/types/mass-operation-types';
import { WithDisposableSubject } from 'core/mixins/with-disposable-subject';

import { MassOperationActivityEventPayload } from '../types';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-mass-assign-to-action-event',
  templateUrl: './mass-assign-to-action-event.component.html'
})

export class ASMassAssignToActionEventComponent extends
  WithDisposableSubject() implements OnInit {

  @Input() item: SearchActivityEvents.Node;

  get payload(): MassOperationActivityEventPayload<MassAddEntitiesToActionOperationData> {
    return this.item?.payload;
  }

  get campaignId() {
    return this._activateRoute.snapshot.queryParams['campaignId'];
  }

  action: {id: string, name: string} = { id: '', name: '' };

  /**
   *
   */
  constructor(
    private _getActionNameGQL: GetActionNameGQL,
    private _activateRoute: ActivatedRoute,
    private _cd: ChangeDetectorRef
  ) {
    super();
  }

  ngOnInit() {
    const actionId = this.payload.operationData.actionId;
    this._getActionNameGQL.fetch({ actionId, campaignId: this.campaignId }).subscribe(
      (res) => {
        this.action = { id: actionId, name: res?.data?.getAction?.name };
        this._cd.markForCheck();
      }
    );
  }

}
